var styles = {"Tag":"_67k8IgWsACc-","text":"xJJ174XSTeQ-","uppercase":"kFY4l9kwG2U-"};

export { styles as default };
//# sourceMappingURL=Tag.module.css.js.map
